import { createAction } from 'redux-actions';

const bookingActions = {
  RELOAD_BOOKING: 'RELOAD_BOOKING',
  FETCH_BOOKING: 'FETCH_BOOKING',
  FETCH_BOOKING_COMPLETED: 'FETCH_BOOKING_COMPLETED',
  FETCH_BOOKING_FAILED: 'FETCH_BOOKING_FAILED',
  FETCH_BOOKING_HOTEL_CONTENT_COMPLETED:
    'FETCH_BOOKING_HOTEL_CONTENT_COMPLETED',
  FETCH_BOOKING_HOTEL_CONTENT_FAILED: 'FETCH_BOOKING_HOTEL_CONTENT_FAILED',
  CLEAR_BOOKING: 'CLEAR_BOOKING',
  PRECANCELLATION_REQUEST: 'BOOKING_PRECANCELLATION_REQUEST',
  PRECANCELLATION_REQUEST_COMPLETED:
    'BOOKING_PRECANCELLATION_REQUEST_COMPLETED',
  PRECANCELLATION_REQUEST_FAILED: 'BOOKING_PRECANCELLATION_REQUEST_FAILED',
  CANCELLATION_REQUEST: 'BOOKING_CANCELLATION_REQUEST',
  CANCELLATION_REQUEST_COMPLETED: 'BOOKING_CANCELLATION_REQUEST_COMPLETED',
  CANCELLATION_REQUEST_FAILED: 'BOOKING_CANCELLATION_REQUEST_FAILED',

  FETCH_BOOKING_ROOM_CONTENT: 'FETCH_BOOKING_ROOM_CONTENT',
  FETCH_BOOKING_ROOM_CONTENT_COMPLETED: 'FETCH_BOOKING_ROOM_CONTENT_COMPLETED',
  FETCH_BOOKING_ROOM_CONTENT_FAILED: 'FETCH_BOOKING_ROOM_CONTENT_FAILED',
  FIRST_LOAD_BOOKING: 'FIRST_LOAD_BOOKING',
  CANCEL_BOOKING_BUTTON_CLICK: 'CANCEL_BOOKING_BUTTON_CLICK',
  CANCEL_BOOKING_CLICK: 'CANCEL_BOOKING_CLICK',
  KEEP_BOOKING_CLICK: 'KEEP_BOOKING_CLICK',
};

const actionCreators = {
  reloadBooking: createAction(bookingActions.RELOAD_BOOKING),
  fetchBooking: createAction(bookingActions.FETCH_BOOKING),
  fetchBookingCompleted: createAction(bookingActions.FETCH_BOOKING_COMPLETED),
  fetchBookingFailed: createAction(bookingActions.FETCH_BOOKING_FAILED),
  fetchBookingHotelContentCompleted: createAction(
    bookingActions.FETCH_BOOKING_HOTEL_CONTENT_COMPLETED
  ),
  fetchBookingHotelContentFailed: createAction(
    bookingActions.FETCH_BOOKING_HOTEL_CONTENT_FAILED
  ),
  clearBooking: createAction(bookingActions.CLEAR_BOOKING),
  requestPrecancellation: createAction(bookingActions.PRECANCELLATION_REQUEST),
  requestPrecancellationCompleted: createAction(
    bookingActions.PRECANCELLATION_REQUEST_COMPLETED
  ),
  requestPrecancellationFailed: createAction(
    bookingActions.PRECANCELLATION_REQUEST_FAILED
  ),
  requestCancellation: createAction(bookingActions.CANCELLATION_REQUEST),
  requestCancellationCompleted: createAction(
    bookingActions.CANCELLATION_REQUEST_COMPLETED
  ),
  requestCancellationFailed: createAction(
    bookingActions.CANCELLATION_REQUEST_FAILED
  ),

  fetchBookingRoomContent: createAction(
    bookingActions.FETCH_BOOKING_ROOM_CONTENT
  ),
  fetchBookingRoomContentCompleted: createAction(
    bookingActions.FETCH_BOOKING_ROOM_CONTENT_COMPLETED
  ),
  fetchBookingRoomContentFailed: createAction(
    bookingActions.FETCH_BOOKING_ROOM_CONTENT_FAILED
  ),
  trackFirstLoadBooking: createAction(bookingActions.FIRST_LOAD_BOOKING),
  trackCancelBookingClick: createAction(
    bookingActions.CANCEL_BOOKING_BUTTON_CLICK
  ),
  trackCancelBooking: createAction(bookingActions.CANCEL_BOOKING_CLICK),
  trackKeepBooking: createAction(bookingActions.KEEP_BOOKING_CLICK),
};

export { bookingActions as types, actionCreators };
